import { Alert, Confirm, Toast, Notify, Loading } from './index.js'
import { MessageBox, Message } from 'element-ui'
import { isClient } from './utils'

const eConfirm = (msg, title, option) => {
  if (isClient()) {
    return new Promise(resolve => {
      Confirm({
        title,
        mes: msg,
        opts: [
          { txt: option.cancelButtonText },
          {
            txt: option.confirmButtonText,
            color: true,
            callback: resolve,
          },
        ],
      })
    })
  }

  return MessageBox.confirm(msg, title, option)
}

const eToast = options => {
  if (isClient()) {
    Toast({ ...options, mes: options.message })
  } else {
    Message({ ...options, type: 'warning' })
  }
}

export default { Alert, eConfirm, eToast, Notify, Loading }
